export default __webpack_public_path__ + "static/media/ico-football.34437d9d.svg";